// extracted by mini-css-extract-plugin
export default {"infoBox":"InfoBox_infoBox__eS3fI","infoBox__icon":"InfoBox_infoBox__icon__O6my+","infoBox_error":"InfoBox_infoBox_error__Qhfxa"};